package io.peekandpoke.kraft.i18n.generated

import io.peekandpoke.ultra.i18n.I18nCatalog
import io.peekandpoke.ultra.i18n.Locale

// Generated by the i18n codegen. Do not edit.

object KraftFormsCatalog : I18nCatalog {
    private val data: Map<String, Map<String, String>> = mapOf(
        "de" to mapOf(
            "forms.empty" to "Muss leer sein",
            "forms.notEmpty" to "Darf nicht leer sein",
            "forms.blank" to "Muss leer sein",
            "forms.notBlank" to "Darf nicht leer sein",
            "forms.minLength_one" to "Muss mindestens {{count}} Zeichen lang sein",
            "forms.minLength_other" to "Muss mindestens {{count}} Zeichen lang sein",
            "forms.maxLength_one" to "Darf höchstens {{count}} Zeichen lang sein",
            "forms.maxLength_other" to "Darf höchstens {{count}} Zeichen lang sein",
            "forms.exactLength_one" to "Muss genau {{count}} Zeichen lang sein",
            "forms.exactLength_other" to "Muss genau {{count}} Zeichen lang sein",
            "forms.validEmail" to "Muss eine gültige E-Mail-Adresse sein",
            "forms.validUrl" to "Muss eine gültige URL sein",
            "forms.validSlug" to "Muss aus Kleinbuchstaben, Ziffern und Bindestrichen bestehen (kein Bindestrich am Anfang oder Ende)",
            "forms.nonNull" to "Darf nicht leer sein",
            "forms.equalTo" to "Die Werte müssen übereinstimmen",
            "forms.notEqualTo" to "Die Werte dürfen nicht übereinstimmen",
            "forms.anyOf" to "Muss eine gültige Eingabe sein",
            "forms.noneOf" to "Muss eine gültige Eingabe sein",
            "forms.invalidInput" to "Ungültige Eingabe",
            "forms.invalidValue" to "Ungültiger Wert",
            "forms.joinOr" to " oder ",
            "forms.joinAnd" to " und ",
            "forms.inRange" to "Muss im Bereich {{from}} .. {{to}} liegen",
            "forms.greaterThan" to "Muss größer als {{limit}} sein",
            "forms.greaterThanOrEqual" to "Muss größer oder gleich {{limit}} sein",
            "forms.lessThan" to "Muss kleiner als {{limit}} sein",
            "forms.lessThanOrEqual" to "Muss kleiner oder gleich {{limit}} sein",
            "forms.collectionNotEmpty" to "Darf nicht leer sein",
            "forms.minCount_one" to "Muss mindestens {{count}} Eintrag haben",
            "forms.minCount_other" to "Muss mindestens {{count}} Einträge haben",
            "forms.maxCount_one" to "Darf höchstens {{count}} Eintrag haben",
            "forms.maxCount_other" to "Darf höchstens {{count}} Einträge haben",
            "forms.exactCount_one" to "Muss genau {{count}} Eintrag haben",
            "forms.exactCount_other" to "Muss genau {{count}} Einträge haben",
        ),
        "en" to mapOf(
            "forms.empty" to "Must be empty",
            "forms.notEmpty" to "Must not be empty",
            "forms.blank" to "Must be blank",
            "forms.notBlank" to "Must not be blank",
            "forms.minLength_one" to "Must be at least {{count}} character",
            "forms.minLength_other" to "Must be at least {{count}} characters",
            "forms.maxLength_one" to "Must be at most {{count}} character",
            "forms.maxLength_other" to "Must be at most {{count}} characters",
            "forms.exactLength_one" to "Must be {{count}} character",
            "forms.exactLength_other" to "Must be {{count}} characters",
            "forms.validEmail" to "Must be a valid email",
            "forms.validUrl" to "Must be a valid url",
            "forms.validSlug" to "Must be lowercase letters, digits and hyphens (no leading or trailing hyphen)",
            "forms.nonNull" to "Must not be empty",
            "forms.equalTo" to "The values must match",
            "forms.notEqualTo" to "The values must not match",
            "forms.anyOf" to "Must be a valid input",
            "forms.noneOf" to "Must be a valid input",
            "forms.invalidInput" to "Invalid input",
            "forms.invalidValue" to "Invalid value",
            "forms.joinOr" to " or ",
            "forms.joinAnd" to " and ",
            "forms.inRange" to "Must be in range {{from}} .. {{to}}",
            "forms.greaterThan" to "Must be greater than {{limit}}",
            "forms.greaterThanOrEqual" to "Must be greater than {{limit}} or equal",
            "forms.lessThan" to "Must be less than {{limit}}",
            "forms.lessThanOrEqual" to "Must be less than {{limit}} or equal",
            "forms.collectionNotEmpty" to "Must not be empty",
            "forms.minCount_one" to "Must have at least {{count}} item",
            "forms.minCount_other" to "Must have at least {{count}} items",
            "forms.maxCount_one" to "Must have at most {{count}} item",
            "forms.maxCount_other" to "Must have at most {{count}} items",
            "forms.exactCount_one" to "Must have {{count}} item",
            "forms.exactCount_other" to "Must have {{count}} items",
        ),
    )

    override fun template(key: String, locale: Locale): String? =
        data[locale.tag]?.get(key)
}
